import { useCallback } from "react"
import { MIN_CLIP_DURATION } from "./constants"

export default function TimelineResizeHandle({
  pxPerSec,
  leftDuration,
  rightDuration,
  onResize,
}: {
  pxPerSec: number
  leftDuration: number
  rightDuration: number
  onResize: (leftDelta: number) => void
}) {
  const handleMouseDown = useCallback(
    (e: React.MouseEvent) => {
      e.preventDefault()
      e.stopPropagation()
      const startX = e.clientX

      function onMove(moveE: MouseEvent) {
        const deltaPx = moveE.clientX - startX
        const deltaSec = deltaPx / pxPerSec
        // Clamp so neither side goes below minimum
        const maxGrow = rightDuration - MIN_CLIP_DURATION
        const maxShrink = -(leftDuration - MIN_CLIP_DURATION)
        const clamped = Math.max(maxShrink, Math.min(maxGrow, deltaSec))
        const rounded = Math.round(clamped * 10) / 10
        if (rounded !== 0) onResize(rounded)
      }

      function onUp() {
        document.removeEventListener("mousemove", onMove)
        document.removeEventListener("mouseup", onUp)
      }

      document.addEventListener("mousemove", onMove)
      document.addEventListener("mouseup", onUp)
    },
    [pxPerSec, leftDuration, rightDuration, onResize],
  )

  return (
    <div
      onMouseDown={handleMouseDown}
      className="absolute top-0 z-10 flex h-full w-1.5 cursor-col-resize items-center justify-center hover:bg-charcoal/[0.08]"
      style={{ marginLeft: -3 }}
    >
      <div className="flex flex-col gap-[2px]">
        <div className="size-[2px] rounded-full bg-charcoal/30" />
        <div className="size-[2px] rounded-full bg-charcoal/30" />
      </div>
    </div>
  )
}
